import { render, staticRenderFns } from "./AccountTaxonomyBreakdown.vue?vue&type=template&id=e488501e&scoped=true"
import script from "./AccountTaxonomyBreakdown.vue?vue&type=script&lang=js"
export * from "./AccountTaxonomyBreakdown.vue?vue&type=script&lang=js"
import style0 from "./AccountTaxonomyBreakdown.vue?vue&type=style&index=0&id=e488501e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e488501e",
  null
  
)

export default component.exports